import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { DashboardLoader } from "../utils/Loading";
import { ServiceApi } from "../services/index.service";
import { enqueueSnackbar } from "notistack";
import { emailValidator } from "../utils";

const EditSettings = (props) => {
  const [Loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [settings, setSettings] = useState(null);
  const serviceapi = new ServiceApi();
  useEffect(() => {
    if (props?.store) {
      fetchStoreSettings();
    }
  }, [props?.store]);

  const fetchStoreSettings = async () => {
    setLoading(true);
    const res = await serviceapi.getStoreSettings(props?.store?.intStoreID);
    if (res?.status === 200) {
      setSettings(res?.data);
    }
    setLoading(false);
  };

  const handleUpdate = async () => {
    const {
      intStoreID,
      bitKosher,
      bitNutFree,
      bitReminderOpt,
      bitCreative,
      isHandScooped,
      ReminderEmail,
      intCSOrTHT,
      intReminderType,
      ReminderPhone,
      intReminderEmailType,
      id = 0,
    } = settings;
    if (
      (bitReminderOpt === true || bitReminderOpt === 1) &&
      intReminderType === 2 && intReminderEmailType===2 &&
      emailValidator(ReminderEmail)
    ) {
      enqueueSnackbar("Please enter valid email", {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: 'error',
      });
      return;
    }
    if (
      (bitReminderOpt === true || bitReminderOpt === 1) &&
      !intReminderType 
    ) {
      enqueueSnackbar("Please select Text Message or Email", {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: 'error',
      });
      return;
    }

    const ReminderPhoneVal = ReminderPhone?.filter((i) => i?.Enabled)?.map(
      (i) => i?.PhoneNumber
    );
    const req = {
      intStoreID,
      id,
      bitKosher: bitKosher === true || bitKosher === 1 ? 1 : 0,
      bitNutFree: bitNutFree === true || bitNutFree === 1 ? 1 : 0,
      bitReminderOpt: bitReminderOpt === true || bitReminderOpt === 1 ? 1 : 0,
      bitCreative: bitCreative === true || bitCreative === 1 ? 1 : 0,
      intCSOrTHT,
      intReminderType,
      ReminderPhone: ReminderPhoneVal,
      intReminderEmailType,
      ReminderEmail,
      isHandScooped,
    };
    setBtnLoading(true);
    const res = await serviceapi.updateStoreSettings(req);
    console.log(res);
    setBtnLoading(false);
    if (res?.status === 200) {
      enqueueSnackbar("Updated Store Settings Successfully", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      props?.handleEditSettings();
    } else {
      enqueueSnackbar("Error in updating store settings", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  const handleChange = (name, value) => {
    setSettings({ ...settings, [name]: value });
  };

  const handlePhoneNumber = (val, dataItem) => {
    console.log(val, dataItem);
    const data = settings?.ReminderPhone?.map((i) => {
      if (dataItem?.PhoneNumber === i?.PhoneNumber) {
        return { ...i, Enabled: val };
      }
      return { ...i };
    });
    setSettings({ ...settings, ReminderPhone: data });
  };

  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth="false"
      sx={{ zIndex: 1000 }}
      open={true}
      onClose={props?.handleEditSettings}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          width: "auto",
          textAlign: "start",
          color: "#044A2A",
          fontSize: "1rem",
        }}
      >
        {"Update Store Settings"}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => props?.handleEditSettings()}
        sx={{
          position: "absolute",
          right: 3,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      {Loading ? (
        <div style={{ width: "auto", height: "450px" }}>
          <DashboardLoader />
        </div>
      ) : (
        <>
          <DialogContent style={{ maxHeight: "450px" }}>
            <Grid container spacing={2}>
              {/* <Grid item xs={6}>
                <span
                  className="font-bold text-[#24211F]"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "600",
                    color: "#24211F",
                  }}
                >
                  Are you Kosher/Halal?
                </span>
                <RadioGroup
                  row
                  name="bitKosher"
                  id="bitKosher"
                  value={settings?.bitKosher ? "1" : "0"}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) =>
                    handleChange("bitKosher", parseInt(e.target.value))
                  }
                >
                  <FormControlLabel
                    value={"1"}
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"Yes"}</span>}
                    className="bitKosher"
                  />
                  <FormControlLabel
                    value={"0"}
                    className="bitKosher"
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"No"}</span>}
                  />
                </RadioGroup>
              </Grid> */}
              {
                settings?.isHandScooped ? (
                  <Grid item xs={6}>
                    <span
                      className="font-bold text-[#24211F]"
                      style={{
                        fontSize: "0.85rem",
                        fontWeight: "600",
                        color: "#24211F",
                      }}
                    >
                      Right Board
                    </span>
                    <RadioGroup
                      row
                      name="intCSOrTHT"
                      id="intCSOrTHT"
                      value={settings?.intCSOrTHT?.toString()}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={(e) =>
                        handleChange("intCSOrTHT", parseInt(e.target.value))
                      }
                    >
                      <FormControlLabel
                        value={"1"}
                        className="intCSOrTHT"
                        control={<Radio size="small" />}
                        label={
                          <span style={{ fontSize: "0.75rem" }}>
                            {"Baked Sandwiches"}
                          </span>
                        }
                      />
                      <FormControlLabel
                        value={"2"}
                        control={<Radio size="small" />}
                        label={
                          <span style={{ fontSize: "0.75rem" }}>
                            {"Take Home Treats"}
                          </span>
                        }
                        className="intCSOrTHT"
                      />
                    </RadioGroup>
                  </Grid>
                ) : null
              }
              <Grid item xs={12}>
                <span
                  className="font-bold text-[#24211F]"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "600",
                    color: "#24211F",
                  }}
                >
                  Do you need Flavor reminders?
                </span>
                <RadioGroup
                  row
                  name="bitReminderOpt"
                  id="bitReminderOpt"
                  value={settings?.bitReminderOpt ? "1" : "0"}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) =>
                    handleChange("bitReminderOpt", parseInt(e.target.value))
                  }
                >
                  <FormControlLabel
                    value={"1"}
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"Yes"}</span>}
                    className="bitReminderOpt"
                  />
                  <FormControlLabel
                    value={"0"}
                    className="bitReminderOpt"
                    control={<Radio size="small" />}
                    label={<span style={{ fontSize: "0.75rem" }}>{"No"}</span>}
                  />
                </RadioGroup>
              </Grid>
              {settings?.bitReminderOpt === true ||
              settings?.bitReminderOpt === 1 ? (
                <>
                  <Grid item xs={12} style={{ paddingTop: "0px" }}>
                    <RadioGroup
                      row
                      name="intReminderType"
                      id="intReminderType"
                      value={settings?.intReminderType?.toString()}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={(e) =>
                        handleChange(
                          "intReminderType",
                          parseInt(e.target.value)
                        )
                      }
                    >
                      <FormControlLabel
                        value={"1"}
                        control={<Radio size="small" />}
                        label={
                          <span style={{ fontSize: "0.75rem" }}>
                            {"Text Message"}
                          </span>
                        }
                        className="intReminderType"
                      />
                      <FormControlLabel
                        value={"2"}
                        className="intReminderType"
                        control={<Radio size="small" />}
                        label={
                          <span style={{ fontSize: "0.75rem" }}>{"Email"}</span>
                        }
                      />
                    </RadioGroup>
                  </Grid>
                  {settings?.intReminderType === 2 ? (
                    <Grid item xs={12}>
                      <RadioGroup
                        row
                        name="intReminderEmailType"
                        id="intReminderEmailType"
                        value={settings?.intReminderEmailType?.toString()}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        onChange={(e) =>
                          handleChange(
                            "intReminderEmailType",
                            parseInt(e.target.value)
                          )
                        }
                      >
                        <FormControlLabel
                          value={"1"}
                          control={<Radio size="small" />}
                          label={
                            <span style={{ fontSize: "0.75rem" }}>
                              {"Store Email"}
                            </span>
                          }
                          className="intReminderEmailType"
                        />
                        <FormControlLabel
                          value={"2"}
                          className="intReminderEmailType"
                          control={<Radio size="small" />}
                          label={
                            <span style={{ fontSize: "0.75rem" }}>
                              {"Add Email Address"}
                            </span>
                          }
                        />
                      </RadioGroup>
                      {settings?.intReminderEmailType === 2 ? (
                        <TextField
                          variant="outlined"
                          placeholder="Please enter email address"
                          value={settings?.ReminderEmail}
                          name="ReminderEmail"
                          id="ReminderEmail"
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            handleChange("ReminderEmail", e.target.value)
                          }
                        />
                      ) : null}
                    </Grid>
                  ) : null}
                  {settings?.intReminderType === 1 &&
                  settings?.ReminderPhone?.length > 0 ? (
                    <Grid item xs={12}>
                      <FormGroup>
                        {settings?.ReminderPhone?.map((i) => {
                          return (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  name={`Phone${i?.PhoneNumber}`}
                                  id={`Phone${i?.PhoneNumber}`}
                                  checked={i?.Enabled}
                                  onChange={(e) =>
                                    handlePhoneNumber(e.target.checked, i)
                                  }
                                />
                              }
                              label={i?.PhoneNumber}
                            />
                          );
                        })}
                      </FormGroup>
                    </Grid>
                  ) : null}
                  {settings?.intReminderType === 1 &&
                  settings?.ReminderPhone?.length === 0 ? (
                    <Grid item xs={12}>
                      <div style={{ fontSize: "0.85rem" }}>
                        Note: There are no phones numbers associated with your
                        store that enrolled in RFC's Text Alert Program. To
                        enroll, please submit a form here:{" "}
                        <a
                          href="https://forms.office.com/Pages/ResponsePage.aspx?id=FyGlDA1pL0ePnrrasRAsL3Zv--f9kJtOjHjOKHC58ppUM1Q3SFRRQTRZMDNGTzdJMFlVRzFXRVdGUy4u"
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            color: "#1976D2",
                          }}
                        >
                          Submit Form
                        </a>
                      </div>
                    </Grid>
                  ) : null}
                </>
              ) : null}
            </Grid>
            <p style={{ paddingTop: "1.25rem", fontSize: "0.85rem" }}>
              {" "}
              <b>Note:</b> Reminders will be not sent when the current date is
              outside of the seasonal dates selected for your store
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outline"
              color="success"
              style={{ border: "1px solid #D41042", color: "#D41042" }}
              onClick={() => props?.handleEditSettings()}
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              color="success"
              loading={btnLoading}
              loadingPosition="start"
              style={{ background: "#D41042" }}
              onClick={() => handleUpdate()}
            >
              Update
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default EditSettings;
